// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design System · Tokens · ERF Operator (R1-VISUAL brand-continuous)
 * Activate by adding class \`ds-theme-erf-operator\` to any ancestor.
 * Status tokens are INVARIANT — do not override across themes.
 *
 * R1-VISUAL-INWARD: Repointed from the pre-brand dark-lux palette to the
 * public R1-VISUAL brand — deep navy canvas, brass primary, ivory text,
 * blueprint-blue info accent, soft-ivory hairlines. Fonts + radii unchanged.
 */
.ds-theme-erf-operator {
  --color-canvas: #0B2545;
  --color-surface: #123056;
  --color-surface-2: #1B3F6C;
  --color-primary: #B08D57;
  --color-primary-emphasis: #C9A576;
  --color-accent: #F5F1E8;
  --color-text: #F5F1E8;
  --color-text-muted: #A9B4C4;
  --color-border: rgba(245, 241, 232, 0.14);
  --color-status-positive: #22C55E;
  --color-status-warning: #F59E0B;
  --color-status-danger: #F87171;
  --color-status-info: #3B82C4;
  --color-status-superseded: #A78BFA;
  --font-display: "Fraunces", "Playfair Display", Georgia, serif;
  --font-body: "Inter Tight", "Inter", system-ui, sans-serif;
  --font-mono: "JetBrains Mono", "IBM Plex Mono", monospace;
  --radius-sm: 4px;
  --radius: 8px;
  --radius-lg: 12px;
  color-scheme: dark;
}
`, "",{"version":3,"sources":["webpack://./src/design-system/tokens/erf-operator.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;AACF;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;EACzC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;EAClC,8DAA8D;EAC9D,0DAA0D;EAC1D,yDAAyD;EACzD,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Design System · Tokens · ERF Operator (R1-VISUAL brand-continuous)\n * Activate by adding class `ds-theme-erf-operator` to any ancestor.\n * Status tokens are INVARIANT — do not override across themes.\n *\n * R1-VISUAL-INWARD: Repointed from the pre-brand dark-lux palette to the\n * public R1-VISUAL brand — deep navy canvas, brass primary, ivory text,\n * blueprint-blue info accent, soft-ivory hairlines. Fonts + radii unchanged.\n */\n.ds-theme-erf-operator {\n  --color-canvas: #0B2545;\n  --color-surface: #123056;\n  --color-surface-2: #1B3F6C;\n  --color-primary: #B08D57;\n  --color-primary-emphasis: #C9A576;\n  --color-accent: #F5F1E8;\n  --color-text: #F5F1E8;\n  --color-text-muted: #A9B4C4;\n  --color-border: rgba(245, 241, 232, 0.14);\n  --color-status-positive: #22C55E;\n  --color-status-warning: #F59E0B;\n  --color-status-danger: #F87171;\n  --color-status-info: #3B82C4;\n  --color-status-superseded: #A78BFA;\n  --font-display: \"Fraunces\", \"Playfair Display\", Georgia, serif;\n  --font-body: \"Inter Tight\", \"Inter\", system-ui, sans-serif;\n  --font-mono: \"JetBrains Mono\", \"IBM Plex Mono\", monospace;\n  --radius-sm: 4px;\n  --radius: 8px;\n  --radius-lg: 12px;\n  color-scheme: dark;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
